export default {
    cookieExpires: 1, //cookie的过期时间
    baseUrl: {
        dev: 'http://www.baidu.com',
        pro: 'http://www.baidu.com'
    },
}